import { DateTime } from 'luxon';

import FORMATTERS from 'helpers/formatters';
import ValidationSchema from './ValidationSchema';

const PAYMENT_FORM = {
  [null]: 'Não informado',
  BANK_SLIP: 'Boleto',
  CREDIT_CARD: 'Cartão de crédito',
  DEBIT_CARD: 'Cartão de débito',
  BANK_CHECK: 'Cheque',
  DIRECT_DEBIT: 'Débito em conta',
  CASH: 'Dinheiro',
  PIX: 'PIX',
  TRANSFER: 'Transferência',
  REMITTANCE: 'Remessa Bancária',
};

const VARIABLES = [
  {
    name: '[DATA_ATUAL]',
    description: 'Data de emissão do recibo (dd/MM/aaaa)',
    group: 'DEFAULT',
    getter: () => DateTime.local().toFormat('dd/MM/yyyy'),
  },
  {
    name: '[HORA_ATUAL]',
    description: 'Hora de emissão do recibo (HH:mm:ss)',
    group: 'DEFAULT',
    getter: () => DateTime.local().toFormat('HH:mm:ss'),
  },
  {
    name: '[DATA_HORA_ATUAL]',
    description: 'Data e Hora de emissão do recibo (dd/MM/aaaa HH:mm:ss)',
    group: 'DEFAULT',
    getter: () => DateTime.local().toFormat('dd/MM/yyyy HH:mm:ss'),
  },
  {
    name: '[MES_ANO_ATUAL]',
    description: 'Mês e Ano de emissão do recibo (MM/aaaa)',
    group: 'DEFAULT',
    getter: () => DateTime.local().toFormat('MM/yyyy'),
  },
  {
    name: 'assets/img/placeholder-img.png',
    description: 'Url do avatar da minha empresa/negócio',
    group: 'DEFAULT',
    getter: ({ company = {} }) =>
      company.company_avatar_url || 'assets/img/placeholder-img.png',
    hidden: true,
  },
  {
    name: '[MEU_NOME]',
    description: 'Nome do usuário logado no momento da emissão',
    group: 'COMPANY',
    getter: ({ user = {} }) => user.full_name,
  },

  {
    name: '[MINHA_EMPRESA_RAZAO_SOCIAL]',
    description: 'Razão Social da minha empresa/negócio',
    group: 'COMPANY',
    getter: ({ company = {} }) => company.company_name,
  },
  {
    name: '[MINHA_EMPRESA_NOME_FANTASIA]',
    description: 'Nome Fantasia da minha empresa/negócio',
    group: 'COMPANY',
    getter: ({ company = {} }) => company.trading_name,
  },
  {
    name: '[MINHA_EMPRESA_DOCUMENTO]',
    description: 'Número do documento da minha empresa/negócio',
    group: 'COMPANY',
    getter: ({ company = {} }) => FORMATTERS.CPF_CNPJ(company.document_number),
  },
  {
    name: '[MINHA_EMPRESA_CIDADE]',
    description: 'Cidade da minha empresa/negócio',
    group: 'COMPANY',
    getter: ({ company = {} }) => company.address_city,
  },
  {
    name: '[MINHA_EMPRESA_ESTADO]',
    description: 'Estado da minha empresa/negócio',
    group: 'COMPANY',
    getter: ({ company = {} }) => company.address_state,
  },
  {
    name: '[MINHA_EMPRESA_LOGOMARCA]',
    description: 'Logomarca da minha empresa/negócio',
    group: 'COMPANY',
    getter: ({ company = {} }) =>
      `<img style="border-radius: 4px;" src="${company.company_avatar_url || 'assets/img/placeholder-img.png'}" width="80" height="80">`,
  },
  {
    name: '[CONTATO_NOME]',
    description: 'Nome do Cliente/Fornecedor/Funcionário',
    group: 'CONTACT',
    getter: ({ contact = {} }) => contact.name || 'Não informado',
  },
  {
    name: '[CONTATO_DOCUMENTO]',
    description: 'CPF ou CNPJ do Cliente/Fornecedor/Funcionário',
    group: 'CONTACT',
    getter: ({ contact = {} }) => FORMATTERS.CPF_CNPJ(contact.document_number),
  },
  {
    name: '[CONTATO_EMAIL]',
    description: 'E-mail do Cliente/Fornecedor/Funcionário',
    group: 'CONTACT',
    getter: ({ contact = {} }) => contact.email || 'Não informado',
  },
  {
    name: '[CONTATO_TELEFONE]',
    description: 'Telefone do Cliente/Fornecedor/Funcionário',
    group: 'CONTACT',
    getter: ({ contact = {} }) => contact.phone_number || 'Não informado',
  },
  {
    name: '[CONTATO_ENDERECO_LOGRADOURO]',
    description: 'Logradouro do Endereço do Cliente/Fornecedor/Funcionário',
    group: 'CONTACT',
    getter: ({ contact = {} }) => contact.address_street || 'Não informado',
  },
  {
    name: '[CONTATO_ENDERECO_NUMERO]',
    description: 'Número do Endereço do Cliente/Fornecedor/Funcionário',
    group: 'CONTACT',
    getter: ({ contact = {} }) => contact.address_number || 'Não informado',
  },
  {
    name: '[CONTATO_ENDERECO_COMPLEMENTO]',
    description: 'Complemento do Endereço do Cliente/Fornecedor/Funcionário',
    group: 'CONTACT',
    getter: ({ contact = {} }) => contact.address_complement || 'Não informado',
  },
  {
    name: '[CONTATO_ENDERECO_BAIRRO]',
    description: 'Bairro do Endereço do Cliente/Fornecedor/Funcionário',
    group: 'CONTACT',
    getter: ({ contact = {} }) => contact.address_district || 'Não informado',
  },
  {
    name: '[CONTATO_ENDERECO_CEP]',
    description: 'CEP do Endereço do Cliente/Fornecedor/Funcionário',
    group: 'CONTACT',
    getter: ({ contact = {} }) => contact.address_zip_code || 'Não informado',
  },
  {
    name: '[CONTATO_ENDERECO_CIDADE]',
    description: 'Cidade do Endereço do Cliente/Fornecedor/Funcionário',
    group: 'CONTACT',
    getter: ({ contact = {} }) => contact.address_city || 'Não informado',
  },
  {
    name: '[CONTATO_ENDERECO_ESTADO]',
    description: 'Estado do Endereço do Cliente/Fornecedor/Funcionário',
    group: 'CONTACT',
    getter: ({ contact = {} }) => contact.address_state || 'Não informado',
  },
];

const TEMPLATES = [];

export { ValidationSchema, VARIABLES, TEMPLATES };
